import {UserTracker} from "../index.js";

const eventDics = {
    "login-click": "corp-sign-in:login:click", // corpsignin 에서 로그인
    "login-enter": "corp-sign-in:login:enter", // corpsignin 에서 엔터 로그인
    "signup": "corp-sign-up:sign-up:move", // corpsignin 에서 corpsignup 이동
    "register": "corp-sign-up:register:click", // corpsignup 에서 회원가입 클릭
    "pw-find-email-click": "corp-sign-in:pw-find-email:click", // corpsignin 비밀번호 변경 이메일 받기 클릭
    "pw-find-email-enter": "corp-sign-in:pw-find-email:enter", // corpsignin 비밀번호 변경 이메일 받기 엔터
}

export const CorpSignTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (eventName) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value: (USE_INTT_ID ?? null), data: {}});
    }

    return Tracker;
}